<template>
  <v-container>
    <v-container>
      <v-row class="d-flex justify-center" align="center">
        <v-col cols="12" md="10">
          <v-row align="center">
            <v-col cols="12" md="6">
              <v-img :src="require('../assets/logo.svg')" class="my-3" contain height="200" />
            </v-col>
            <v-col cols="12" md="6" align-self="center" class="text-center text-md-left">
              <div class="text-h3 ma-5">EmbryoScan</div>
              <div class="text-h5 ma-5">{{
                t('Avanzando_el_cribado_rutinario_del_embarazo_con_ecografía_asistida_por_IA') }}</div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center" align="center">
        <v-col cols="12" md="10">
        </v-col>
      </v-row>
    </v-container>


    <v-row class="d-flex justify-center bg-blue-grey-lighten-5" align="center" no-gutters>

      <v-col cols="12" md="10">
        <v-card class="ma-5 text-justify" variant="text">
          <v-card-title>{{ t('Qué_es_EmbryoScan') }}</v-card-title>
          <v-card-text class="multiline-text">{{ t('EmbryoScan_es') }}</v-card-text>
          <v-card-title>{{ t('Por_qué_es_importante') }}</v-card-title>
          <v-card-text>
            <ul class="pl-7">
              <li>
                {{ t('Por_qué_es_importante_text_c1') }}
              </li>
              <li>
                {{ t('Por_qué_es_importante_text_c2') }}
              </li>
              <li>
                {{ t('Por_qué_es_importante_text_c3') }}
              </li>
            </ul>
          </v-card-text>
          <v-card-title>{{ t('Por_qué_tu_opinión_es_clave') }}</v-card-title>
          <v-card-text>{{ t('Por_qué_tu_opinión_es_clave_text') }}</v-card-text>
          <v-card-title>{{ t('Cómo_puedes_participar') }}</v-card-title>
          <v-card-text>{{ t('Cómo_puedes_participar_text') }}
            <ul class="pl-7">
              <li>
                {{ t('Cómo_puedes_participar_text_c1') }}
              </li>
              <li>
                {{ t('Cómo_puedes_participar_text_c2') }}
              </li>
              <li>
                {{ t('Cómo_puedes_participar_text_c3') }}
              </li>
            </ul>
          </v-card-text>
          <v-card-title>{{ t('Tu_voz_importa') }}</v-card-title>
          <v-card-text>{{ t('Tu_voz_importa_text') }}</v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="primary" href="mailto:alba.farras@vallhebron.cat">{{ t('Contáctanos') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>

<style scoped>
.multiline-text {
  white-space: pre-line;
}
</style>